<template>
  <span v-bind="$attrs">
    <v-chip
      :class="{ border: outlined }"
      data-testid="status-chip"
      density="comfortable"
      :variant="onSurface ? 'flat' : 'tonal'"
      :color="onSurface ? 'background' : ''"
    >
      <template #prepend>
        <v-icon
          ref="icon"
          start
          icon="circle"
          :color="status.type"
          size="x-small"
        ></v-icon>
      </template>
      <div class="text-body-2">{{ status.text }}</div>
      <span v-if="text">
        {{ text }}
      </span>
    </v-chip>
  </span>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { Status } from "@/types/Status"

  export default defineComponent({
    inheritAttrs: false,
    props: {
      status: {
        type: Object as PropType<Status>,
        default: { type: "default", text: "" } as Status,
      },
      text: {
        type: String,
        required: false,
        default: "",
      },
      outlined: {
        type: Boolean,
        default: false,
      },
      onSurface: {
        type: Boolean,
        default: false,
      },
    },
  })
</script>

<style scoped>
  :deep(.v-chip__underlay) {
    background: rgb(var(--v-theme-surface-dim));
    opacity: 1;
  }
  :deep(.v-chip__content) {
    z-index: 1;
  }
</style>
